module.exports = __webpack_public_path__ + "img/16.37d35c43.jpg";